import "./CheckBoxGroupFilter.css";

const CheckBoxGroupFilter = ({ data, originalData, onChange, wrapFlex }) => {
  const handleChange = (itemSeleccionado) => {
    let filterData = originalData ? originalData : data;
    const updatedData = filterData.map((item) =>
      item.id === itemSeleccionado.id
        ? { ...item, checked: !item.checked }
        : item
    );
    onChange(updatedData);
  };

  return (
    <div
      className={
        wrapFlex
          ? "wrap-checkBoxGroupFilter-container"
          : "ptur-checkBoxGroupFilter-container"
      }
      id={Math.random()}
    >
      {data?.map((item, index) => {
        return (
          <label
            className={`checkbox-container`}
            style={{ width: wrapFlex ? "25vh" : "fit-content" }}
            id={index + item.descripcion}
          >
            <input
              type="checkbox"
              checked={item.checked}
              onChange={() => handleChange(item)}
              className="hidden-checkbox"
            />
            <div className="custom-checkbox">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12L10 16L18 8" /* Define el trazo del tilde */
                  className="checkbox-path"
                />
              </svg>
            </div>
            <span className="rb14l">{item.descripcion}</span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckBoxGroupFilter;
